// import React ,{useContext} from "react";
// import AuthContext from "../../context/auth/authContext";
// import setAuthToken from "../../functions/auth_header";
// import { getAppUrl } from "../../functions/getEnv";
// import axios from "axios";
// import { exportToXLSX } from "./exportUtils";

// const ExportExcelButton = ({ data }) => {
//   const authContext = useContext(AuthContext);
//   const { user } = authContext;
//   const appUrl = getAppUrl(process.env.NODE_ENV);
//   // console.log(user?.name, user?.azureID, user?.userStatus);

//   const handleExport = async () => {
//     try {
//     exportToXLSX(data, "interest_data.xlsx");

//     if (localStorage.token) {
//       setAuthToken(localStorage.token);
//     }
//     const response = await axios.post(`${appUrl}/api/dataexport`, {
//       user_name: user?.name,
//       azure_id: user?.azureID,
//       fileName: "interest_data.xlsx",
//       recordCount: data.length,
//       screen:"Interest Entries Admin Screen ",
//       exportType: "excel", 
//       exportStatus: "success" 
//     });

//     // console.log("Export logged successfully:", response.data);
//   } catch (error) {
//     console.error("Error during export:", error);
//   }
//   };

//   return (
//     <button className="btn btn-llac-dark-grey" onClick={handleExport}>
//       Export to Excel
//     </button>
//   );
// };

// export default ExportExcelButton;
import React, { useContext, useState } from "react";
import { exportToXLSX } from "./exportUtils";
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";

import axios from "axios";

const ExportExcelButton = ({
  getCurrentFilters,
  appUrl: reactAppUrl, 
  onExportStart,
  onExportComplete
}) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
    const adminemailLogsContext = useContext(AdminemailLogsContext);
   const {
    getIntEntriesOptimize, // Your interest entries fetch function
    searchText,
    startDate,
    endDate,
    loading,
    setLoading
  } = adminemailLogsContext;

  const [isExporting, setIsExporting] = useState(false);
	const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const handleExport = async () => {
    try {
      setIsExporting(true);
     
      
      // Call parent's onExportStart callback to show the message
      if (onExportStart) {
        onExportStart();
      }

      // Get current filter parameters
      const filters = getCurrentFilters();
     // console.log("Export filters",filters)

      // Fetch data from backend with current filters (all data without pagination)
      const exportData = await getIntEntriesOptimize({
        learningCenterCharter: filters.charterName,
        learningCenterName: filters.learningCenterName,
        status: filters.status,
        emailType: filters.emailType,
        searchText: filters.searchText || searchText,
        startDate: filters.startDate || startDate,
        endDate: filters.endDate || endDate,
      });

      // Prepare data for export
      const dataToExport = Array.isArray(exportData)
        ? exportData.map((item) => ({
          ...item,
         // PermaLink: `${reactAppUrl}/forms/${item.permaLink}/${item._uuid}`,
        }))
        : [];

      if (dataToExport.length === 0) {
        alert("No data available to export with the current filters.");
        return;
      }

      // Export to Excel
      exportToXLSX(dataToExport, "Email_Logger.xlsx");

      // Log export activity
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      await axios.post(`${appUrl}/api/dataexport`, {
        user_name: user?.name,
        azure_id: user?.azureID,
        fileName: "Email_logger.xlsx",
        recordCount: dataToExport.length,
        screen: "Email Logger Admin Screen",
        exportType: "excel",
        exportStatus: "success",
      });

    } catch (error) {
      console.error("Error during export:", error);
      alert("Failed to export data. Please try again.");
      
      // Log failed export
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        await axios.post(`${appUrl}/api/dataexport`, {
          user_name: user?.name,
          azure_id: user?.azureID,
          fileName: "Email_logger.xlsx",
          recordCount: 0,
          screen: "Email Logger Admin Screen",
          exportType: "excel",
          exportStatus: "failed",
        });
      } catch (logError) {
        console.error("Error logging failed export:", logError);
      }
    } finally {
      setIsExporting(false);
     
      
      // Call parent's onExportComplete callback to hide the message
      if (onExportComplete) {
        onExportComplete();
        
      }
    }
  };

  return (
    <button
      className="btn btn-llac-dark-grey"
      onClick={handleExport}
      disabled={isExporting}
      style={{
        fontSize: "15px",
        padding: "10px 25px",
        height: "46px",
        cursor: isExporting ? "not-allowed" : "pointer",
        opacity: isExporting ? 0.7 : 1,
         backgroundColor: isExporting ? "#6c757d" : "#537131", // Green background
        color: "white",
        border: "none",
        borderRadius: "4px",
        fontWeight: "500",
        transition: "all 0.2s ease-in-out",
      }}
      
    >
      {(isExporting ) ? "Exporting..." : "Export to Excel"}
    </button>
  );
};

export default ExportExcelButton;